import axios, { AxiosResponse } from 'axios'
import { appCallbackHandler } from '../../util/AppCallbackHandler'
import { ENV } from '../../env/base'

// check url
const { BASE_URL } = ENV()

export const AxiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})

AxiosInstance.interceptors.response.use(
    async (response: AxiosResponse) => {
        if (response.data.Token) {
        } else if (response.data.errormsg) {
        }
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response.data
    },
    (err: any) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        const status = err.response?.status || 500

        switch (status) {
            // authentication (token related issues)
            case 401: {
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('FUTURE_USER_ID')
                appCallbackHandler('pageIsLoaded')
                console.log("Sending 'token 401 invalid' message to parent")
                window.parent.postMessage(
                    { success: true, message: 'token is invalid' },
                    '*'
                )
                window.parent.postMessage({ requestToken: true }, '*')

                if (window.location.pathname !== '/') {
                    window.open('/', '_self')
                }
                console.log('status: 401, send token again')
                return Promise.reject(err.message)
            }

            // // forbidden (permission related issues)
            case 403: {
                if (
                    err.response?.data?.message &&
                    err.response?.data?.message ===
                        'you are not allowed to change the profile name'
                ) {
                    return err.response?.data?.message
                } else {
                    window.location.reload()
                    window.localStorage.removeItem('token')
                    window.localStorage.removeItem('FUTURE_USER_ID')
                    appCallbackHandler('pageIsLoaded')
                    console.log("Sending 'token is 403' message to parent")
                    window.parent.postMessage(
                        { success: true, message: 'token is invalid' },
                        '*'
                    )
                    window.parent.postMessage({ requestToken: true }, '*')

                    console.log('status: 403, send token again')

                    if (window.location.pathname !== '/') {
                        window.open('/', '_self')
                    }
                    return Promise.reject(err.message)
                }
            }

            // bad request
            case 400: {
                let errorApi: any = {}
                errorApi = err.response?.data as any
                const error = errorApi ? errorApi.message : err.message
                console.log('status: 400', error || '')
                if (error === 'Could not find merchant info.') {
                    window.localStorage.removeItem('token')
                    window.localStorage.removeItem('FUTURE_USER_ID')
                    window.parent.postMessage({ requestToken: true }, '*')
                    appCallbackHandler('pageIsLoaded')
                    window.open('/')
                }
                return Promise.reject(err.response)
            }

            case 409: {
                console.log('error status: 409')
                return Promise.reject(err.message)
            }

            // unprocessable
            case 422: {
                console.log('error status: 422')
                return Promise.reject(err.message)
            }

            // generic api error (server related) unexpected
            default: {
                console.log('error status:server related')
                return Promise.reject(err.message)
            }
        }
    }
)

AxiosInstance.interceptors.request.use(
    (config: any) => {
        if (config.headers) {
            //@ts-ignore
            config.headers['x-btz-token'] = window.localStorage.getItem('token')
        }
        return config
    },

    (error) => Promise.reject(error)
)
